import React, { useState } from "react";
import { keys } from "lodash";
import { Button, Modal, ModalBody, ModalFooter } from "reactstrap";
import { ApiClient } from "services";
import { PendingButton } from "components/common";
import { NotificationManager } from "react-notifications";
import { Trans, useTranslation } from "react-i18next";

export const BulkArchiveButton = ({
  selected,
  url,
  onArchived,
  buttonProps,
  readOnly,
  client,
  entity = "organisation",
  ...props
}) => {
  const { t } = useTranslation();
  const [isOpen, setIsOpen] = useState(false);
  const [pending, setPending] = useState(false);

  const api = client || ApiClient();
  const ids = keys(selected);
  const numSelected = ids.length;

  if (readOnly) return null;

  const toggle = () => setIsOpen((prev) => !prev);

  const onConfirm = async () => {
    setPending(true);

    try {
      await api.delete(`${url}/${ids.join(",")}`);
      NotificationManager.success(t("{{entity}}(s) archived successfully", { entity: t(entity) }));
      if (onArchived) onArchived();
    } catch (e) {
      NotificationManager.error(t("{{entity}}(s) could not be archived", { entity: t(entity) }));
    } finally {
      setPending(false);
      setIsOpen(false);
    }
  };

  return (
    <div {...props}>
      <Button
        onClick={toggle}
        disabled={!numSelected}
        color="danger"
        {...buttonProps}
      >
        <span className="fa fa-trash" /> <Trans>Archive selected</Trans>{" "}
        {!!numSelected && <span>({numSelected})</span>}
      </Button>
      <Modal isOpen={isOpen} toggle={toggle}>
        <ModalBody>
          <div className="text-center mt-2 alert alert-warning mb-0" role="alert">
            <h4 className="text-warning">
              <Trans>WARNING!</Trans>
            </h4>
            <p className="my-1" style={{ fontSize: "1.1em" }}>
              {t("Are you sure to archive the selected {{entity}}(s)?", { entity: t(entity) })}
            </p>
          </div>
        </ModalBody>
        <ModalFooter>
          <PendingButton color="danger" pending={pending} onClick={onConfirm}>
            <Trans>Confirm</Trans>
          </PendingButton>{" "}
          <Button color="secondary" onClick={toggle}>
            <Trans>Cancel</Trans>
          </Button>
        </ModalFooter>
      </Modal>
    </div>
  );
};

export default BulkArchiveButton;
